import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";

export const UpdateorCancelButtons = ({ onSave, onCancel }) => {
 
  const Gstate = useSelector((state) => state) || {};
  const isEditable = Gstate.authorizationData.isEditable;

  const params = useParams();
  const saveOrUpdate = params.CompanyId !== "0" ? "Update" : "Save"
  
  return (<>
 
    <div className="m-3 d-flex justify-content-end" style={{paddingBottom: "15px"}}>
          <button
            className="s-sm-btn"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="ms-2 p-sm-btn"
            onClick={onSave}
            disabled={!isEditable}
            id="savePostBtn"
          >
            {saveOrUpdate}
          </button>
        </div>
  </>
  );
};
